import * as Yup from "yup";
import { DefaultStepSchema } from "./required.schema";

export const ActionFormSchema = DefaultStepSchema.concat(Yup.object().shape({
    go_to: Yup.string().required("Debe definir una acción.")
}));